import { gsap } from "gsap";
import { useEffect, useRef } from "react";
import useAnimationStore from "../stores/use-animation";
import useAnswersStore from "../stores/use-answers";
import { RotateCcw } from "lucide-react"
import { Howl } from "howler";
import fingerSnapSound from "../assets/audio/finger-snap.mp3"

export function Card() {
  const cardRef = useRef(null);
  const timeline = useRef(null)
  const flipCardSound = useRef(null)
  const { isShowResult, replay, isReplaying } = useAnimationStore();
  const { answer, getRandomAnswer} = useAnswersStore()
  useEffect(() => {
    flipCardSound.current = new Howl({
      src: [fingerSnapSound],
      volume: 0.8,
      rate: 1
    })
    timeline.current = gsap.timeline({paused: true})
    .to(cardRef.current, { scale: 1, opacity: 1, duration: 1.5 })
    .to(cardRef.current, { rotateY: 180, delay: 1, duration: 0.6, ease: "power2.inOut" }, ">")
    .add(() => flipCardSound.current.play(), "<")



    return () => {
      timeline.current?.kill()
    }
  }, [])

  useEffect(() => {
    if (isShowResult) {
      timeline.current.play()
      getRandomAnswer()
    }
  }, [isShowResult]);
  useEffect(() => {
    if (isReplaying) {
      timeline.current.reverse()
    }
  }, [isReplaying]);

  return (
    <div className="fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 z-0">
      <div

        ref={cardRef}
        className="relative w-[300px] h-[50vh] scale-0 transition-transform [transform-style:preserve-3d]"
      >
        {/* Mặt trước */}
        <div className="absolute w-full h-full bg-background border border-primary rounded-lg flex flex-col items-center justify-center [transform:rotateY(180deg)] [backface-visibility:hidden] text-center p-4">
          <div className="space-y-8">
            <p>{answer.vi}</p>
            <p>/{answer.en}/</p>
          </div>
          <RotateCcw onClick={() => replay()} className="absolute bottom-4 cursor-pointer text-gold"/>
        </div>

        {/* Mặt sau */}
        <div className="absolute w-full h-full bg-primary border border-primary text-white rounded-lg flex items-center justify-center  [backface-visibility:hidden]">

        </div>
      </div>
    </div>
  );
}
